import { useEffect, useState } from 'react';
import { fetchPaymentMarket } from './client';
import { MARKET_KR, normalizeMarket } from './catalog';

const FALLBACK_MARKET = {
    country: 'KR',
    market: MARKET_KR,
    currency: 'KRW',
    payment_provider: 'toss',
};

export function useMarket() {
    const [state, setState] = useState({ loading: true, data: FALLBACK_MARKET, error: null });

    useEffect(() => {
        let cancelled = false;
        fetchPaymentMarket()
            .then((result) => {
                if (cancelled) return;
                setState({
                    loading: false,
                    data: {
                        ...FALLBACK_MARKET,
                        ...result,
                        market: normalizeMarket(result?.market),
                    },
                    error: null,
                });
            })
            .catch((error) => {
                if (cancelled) return;
                console.warn('[payments] Failed to load market; falling back to KR.', error);
                setState({ loading: false, data: FALLBACK_MARKET, error });
            });

        return () => { cancelled = true; };
    }, []);

    return state;
}
